import { useState, useEffect } from 'react'
import Helmet from 'react-helmet'

import LanguageContext from '~/context/language'
import { Language, normalizeLanguage } from '~/utils/language'
import DownloadPage from '~/pages/DownloadPage'
import MpayDownloadPage from '~/pages/MpayDownloadPage'
import CNDownloadPage from '~/pages/CNDownloadPage'

import styles from './App.module.css'

function App() {
  const [language, setLanguage] = useState<Language>()
  useEffect(() => {
    const nextLanguage = normalizeLanguage(window.navigator.language)
    setLanguage(nextLanguage)
  }, [])

  if (!language) return null

  const isMpayPage = process.env.REACT_APP_PAGE === 'mo'
  const isCNPage = process.env.REACT_APP_PAGE === 'cn'

  return (
    <LanguageContext.Provider value={language}>
      <div className={styles.root}>
        <Helmet>
          <title>ChargeSPOT</title>
        </Helmet>

        {!isMpayPage && !isCNPage && <DownloadPage />}
        {isMpayPage && <MpayDownloadPage />}
        {isCNPage && <CNDownloadPage />}
      </div>
    </LanguageContext.Provider>
  )
}

export default App
